/** Stories expire after 48 hours. */
export const SOCIAL_POST_TTL_MS = 48 * 60 * 60 * 1000;

/** Maximum active posts per user in the home strip. */
export const SOCIAL_POST_MAX_PER_USER = 5;

/** Max raw upload size for video stories (trimmed to 30s before save). */
export const SOCIAL_POST_MAX_VIDEO_BYTES = 32 * 1024 * 1024;

export const SOCIAL_POST_MAX_VIDEO_MB = SOCIAL_POST_MAX_VIDEO_BYTES / (1024 * 1024);

export const SOCIAL_POST_MAX_AUDIO_BYTES = 8 * 1024 * 1024;

export const SOCIAL_POST_MAX_IMAGE_BYTES = 4 * 1024 * 1024;

/** Max playback / upload length for video stories (seconds). */
export const SOCIAL_POST_MAX_VIDEO_DURATION_SEC = 30;

/** Max playback / upload length for photo + optional audio stories (seconds). */
export const SOCIAL_POST_MAX_IMAGE_AUDIO_DURATION_SEC = 10;

/** @deprecated Prefer {@link SOCIAL_POST_MAX_VIDEO_DURATION_SEC} or image-audio duration. */
export const SOCIAL_POST_MAX_MEDIA_DURATION_SEC = SOCIAL_POST_MAX_VIDEO_DURATION_SEC;

/** How long an image story stays visible before advancing. */
export const SOCIAL_STORY_IMAGE_DURATION_MS = SOCIAL_POST_MAX_IMAGE_AUDIO_DURATION_SEC * 1000;

export const SOCIAL_POSTS_UPDATED_EVENT = 'ofrontend:social-posts-updated';
